<template>
  <node-view-wrapper class="row" />
</template>

<script>
import {
  NodeViewWrapper,
  nodeViewProps,
} from '@tiptap/vue-2';

export default {
  components: {
    NodeViewWrapper,
  },
  props: {
    ...nodeViewProps,
  },
};
</script>
